// extracted by mini-css-extract-plugin
export var animationContainer = "_if-0";
export var footer = "_if-1";
export var gray = "_if-2";
export var lineItem = "_if-3";
export var lineItemImage = "_if-4";
export var lineItemInfo = "_if-5";
export var lineItemText = "_if-6";
export var lineItems = "_if-7";
export var modalContent = "_if-8";
export var options = "_if-9";
export var orderName = "_if-a";
export var refundAmount = "_if-b";